import MessageBox from "components/CSRAdmin/FormElements/MessageBox";
import { useTranslation } from "react-i18next";

export default function Message({
  register,
  errors,
  startingWordCount,
  setIsMessageFill,
  MESSAGEMAXIMUMWORDCOUNT = 300,
}) {
  const { t } = useTranslation();
  return (
    <MessageBox
      labelName={t("AgentCSR-Admin-Message-label")}
      containerClassName="col-span-1 lg:col-span-3"
      register={register}
      name="message"
      maximumWordCount={MESSAGEMAXIMUMWORDCOUNT}
      validationsProps={{
        required: "Please enter a message",
        maxLength: {
          value: MESSAGEMAXIMUMWORDCOUNT,
          message: "Maximum characters exceeded.",
        },
      }}
      validationMessage={errors?.message?.message}
      startingWordCount={startingWordCount}
      textAlign={"text-right"}
      rows="5"
      setIsMessageFill={setIsMessageFill}
    />
  );
}
